import React, {useEffect} from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {

    return (
        <div className="wrapper">
            <Header />
            <main className="main-content">
                {children}
            </main>
            <Footer />
            <div id="scroll-to-top" className="scroll-to-top">
                <span className="fa fa-angle-up"></span>
            </div>
        </div>
    );
};

export default Layout;